/* @flow */
import { Component } from "react";

type RequirementProps<T> = {
  status: string,
  onData: (T) => void,
  onError: (Error) => void,
  fetch: () => Promise<T>,
};

class DataRequirement extends Component<RequirementProps<*>> {
  request = () => this.props.fetch();
  receive = (data: *) => this.props.onData(data);
  handleError = (error: Error) => this.props.onError(error);

  componentDidMount() {
    if (this.props.status === "PENDING") {
      this.request().then(this.receive, this.handleError);
    }
  }

  componentDidUpdate(prevProps: RequirementProps<*>) {
    if (
      this.props.status !== prevProps.status &&
      this.props.status === "PENDING"
    ) {
      this.request().then(this.receive, this.handleError);
    }
  }

  render() {
    return null;
  }
}

export default DataRequirement;



// WEBPACK FOOTER //
// ./src/components/DataRequirement.js